export default __webpack_public_path__ + "static/media/ellipse_need_help.17aef685.svg";